import 'babel-polyfill'
import 'es6-promise/auto'
import 'svgxuse'
import Vue from 'vue'
import axios from 'axios'
import VueMoment from 'vue-moment'
import 'moment/locale/lv'
import App from './App.vue'
import store from './store/index'
import router from './router.js'
import VeeValidate, { Validator } from 'vee-validate';
import Notifications from 'vue-notification'
import VueProgressBar from 'vue-progressbar'
import Reveal from './components/common/Reveal'
import VueAxios from 'vue-axios'
import './bootstrap'
import lv from './lang/lv/validatoin';
import './filters/time'
import Spinner from 'vue-simple-spinner'

Validator.localize('lv', lv);

Vue.use(VueMoment);
Vue.use(VueAxios, axios);
Vue.use(VeeValidate);
Vue.use(Notifications);
Vue.use(VueProgressBar);

Vue.component('reveal', Reveal);
Vue.component('spinner', Spinner);

VeeValidate.Validator.extend('verify_password', {
    getMessage: field => `The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character (E.g. , . _ & ? etc)`,
    validate: value => {
        var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
        return strongRegex.test(value);
    }
});

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.auth) && store.getters.isAuthenticated === false) {

        //TODO implement intented url query or in store
        //this.$router.push({ query: Object.assign(this.$route.query, { intended: 'param' }) })

        // On first app load, $modal is not yet available. We handle auth redirect differently.
        if (router.app.$modal) {
            router.app.$router.push('/');
            router.app.$modal.openReveal(require('./components/auth/LoginReveal'));
        } else {
            router.app.$router.push({ name: 'auth.login' });
        }

    } else {
        next();
    }
});

/* eslint-disable no-new */
const vm = new Vue({
    el: '#root',
    router,
    store,
    template: '<app/>',
    components: { App },
    created() {
        /**
         * Request user globally if authenticated
         */
        if (this.$store.getters.isAuthenticated) {
            this.$store.dispatch('getUser')
        }

        /**
         * Show axios request progress
         */
        axios.interceptors.request.use(request => {
                this.$Progress.start()
                return request
            }, error => {
                // Do something with response error
                return Promise.reject(error)
            });

        /**
         * Terminate axios request progress
         */
        axios.interceptors.response.use(response => {
                this.$Progress.finish()
                return response
            }, error => {
                this.$Progress.fail()
                //Add debug notification
                // this.$notify({
                //     type: 'error',
                //     title: error.response.statusText,
                //     text: _.get(error, 'response.data.message', error.message)
                // })

                return Promise.reject(error.response)
            });
    }
});




// WEBPACK FOOTER //
// ./resources/assets/js/app.js